import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface useZipcodeDataProps {
  onMutate?: () => void;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

const useZipcodeData = ({ onMutate, onSuccess, onError }: useZipcodeDataProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['initializeFromZipcode'],
    mutationFn: (zipcode: string) => {
      const payload = { address: { zipcode } };

      return privateAxios.post("/geo/addresses/initialize_from_zipcode", payload);
    },
    onMutate,
    onSuccess,
    onError,
  });
};

export default useZipcodeData;
